import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';

export const EmailMockup = () => (
	<Paper
		elevation={0}
		sx={{
			borderRadius: 3,
			border: '1px solid',
			borderColor: 'divider',
			overflow: 'hidden',
			height: '100%',
		}}
	>
		<Box
			sx={{
				px: 2,
				py: 1.5,
				bgcolor: '#1a202c',
				color: '#ffffff',
				textAlign: 'center',
			}}
		>
			<Box
				sx={{
					width: 36,
					height: 36,
					borderRadius: '50%',
					bgcolor: 'primary.main',
					mx: 'auto',
					mb: 1,
				}}
			/>
			<Typography
				variant="caption"
				sx={{ display: 'block', opacity: 0.85, mb: 0.5 }}
			>
				From: Ridgeline Trade Co.
			</Typography>
			<Typography
				variant="subtitle2"
				sx={{ fontWeight: 700, letterSpacing: '0.04em' }}
			>
				RIDGELINE TRADE CO.
			</Typography>
		</Box>
		<Box
			sx={{
				px: 2,
				py: 1.25,
				borderBottom: '1px solid',
				borderColor: 'divider',
			}}
		>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'block' }}
			>
				Subject
			</Typography>
			<Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
				[Sample] New Bid Proposal - Kitchen Remodel
			</Typography>
		</Box>
		<Box sx={{ p: 2.5 }}>
			<Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
				New Bid Proposal
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
				Hello Alex,
			</Typography>
			<Typography variant="body2" sx={{ mb: 2, lineHeight: 1.7 }}>
				We have prepared the following bid proposal for your project.
			</Typography>
			<Box
				sx={{
					p: 2,
					borderRadius: 1,
					borderLeft: '4px solid',
					borderColor: 'info.main',
					bgcolor: 'action.hover',
					mb: 2,
				}}
			>
				<Typography variant="body2">
					<strong>Job:</strong> Kitchen Remodel
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
					Remove existing cabinets, install new shaker-style cabinetry, and
					replace countertops with quartz.
				</Typography>
				<Typography variant="body2" sx={{ mt: 1 }}>
					<strong>Amount:</strong>{' '}
					<Box component="span" sx={{ color: 'info.main', fontWeight: 700 }}>
						$8,450.00
					</Box>
				</Typography>
				<Typography
					variant="caption"
					color="text.secondary"
					sx={{ display: 'block', mt: 1 }}
				>
					Valid until 07/23/2026
				</Typography>
			</Box>
			<Typography
				variant="caption"
				color="primary"
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 0.5,
					mb: 2,
					fontWeight: 600,
				}}
			>
				<LinkIcon sx={{ fontSize: 14 }} />
				View current bid status
			</Typography>
			<Stack
				direction="row"
				spacing={1}
				justifyContent="center"
				sx={{ mb: 1.5 }}
			>
				<Button
					size="small"
					variant="contained"
					sx={{ minWidth: 100, pointerEvents: 'none' }}
				>
					Accept this bid
				</Button>
				<Button size="small" color="inherit" sx={{ pointerEvents: 'none' }}>
					Decline
				</Button>
			</Stack>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'block', textAlign: 'center', lineHeight: 1.5 }}
			>
				By clicking Accept, you agree to the terms of this proposal and
				authorize Ridgeline Trade Co. to proceed with the work described.
			</Typography>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'block', textAlign: 'center', mt: 2, lineHeight: 1.6 }}
			>
				Please find the attached bid proposal PDF for your records.
			</Typography>
		</Box>
		<Box sx={{ px: 2, py: 1.5, mt: 8.5, bgcolor: 'action.hover', textAlign: 'center' }}>
			<Typography variant="caption" color="text.secondary">
				Ridgeline Trade Co. · hello@ridgelinetrade.co | (303) 555-0142
			</Typography>
		</Box>
	</Paper>
);

export const InvoiceEmailMockup = () => (
	<Paper
		elevation={0}
		sx={{
			borderRadius: 3,
			border: '1px solid',
			borderColor: 'divider',
			overflow: 'hidden',
			height: '100%',
		}}
	>
		<Box
			sx={{
				px: 2,
				py: 1.5,
				bgcolor: '#1a202c',
				color: '#ffffff',
				textAlign: 'center',
			}}
		>
			<Box
				sx={{
					width: 36,
					height: 36,
					borderRadius: '50%',
					bgcolor: 'primary.main',
					mx: 'auto',
					mb: 1,
				}}
			/>
			<Typography
				variant="caption"
				sx={{ display: 'block', opacity: 0.85, mb: 0.5 }}
			>
				From: Ridgeline Trade Co.
			</Typography>
			<Typography
				variant="subtitle2"
				sx={{ fontWeight: 700, letterSpacing: '0.04em' }}
			>
				RIDGELINE TRADE CO.
			</Typography>
		</Box>
		<Box
			sx={{
				px: 2,
				py: 1.25,
				borderBottom: '1px solid',
				borderColor: 'divider',
			}}
		>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'block' }}
			>
				Subject
			</Typography>
			<Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
				[Sample] Job Invoice - Kitchen Remodel
			</Typography>
		</Box>
		<Box sx={{ p: 2.5 }}>
			<Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
				Job Invoice
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
				Hello Alex,
			</Typography>
			<Typography variant="body2" sx={{ mb: 2, lineHeight: 1.7 }}>
				Thank you for the opportunity to work with you. Please find the invoice
				for our services below.
			</Typography>
			<Box
				sx={{
					p: 2,
					borderRadius: 1,
					borderLeft: '4px solid',
					borderColor: 'info.main',
					bgcolor: 'action.hover',
					mb: 2,
				}}
			>
				<Typography variant="body2">
					<strong>Job:</strong> Kitchen Remodel
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
					Remove existing cabinets, install new shaker-style cabinetry, and
					replace countertops with quartz.
				</Typography>
				<Typography variant="body2" sx={{ mt: 1 }}>
					<strong>Amount:</strong>{' '}
					<Box component="span" sx={{ color: 'info.main', fontWeight: 700 }}>
						$6,760.00
					</Box>
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
					<strong>Deposit paid:</strong> $1,690.00
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
					<strong>Balance due:</strong> $6,760.00
				</Typography>
			</Box>
			<Stack direction="row" justifyContent="center" sx={{ mb: 2 }}>
				<Button
					size="small"
					variant="contained"
					sx={{ minWidth: 140, pointerEvents: 'none' }}
				>
					Pay invoice online
				</Button>
			</Stack>
			<Box
				sx={{
					p: 1.5,
					borderRadius: 1,
					borderLeft: '4px solid',
					borderColor: 'success.main',
					bgcolor: 'rgba(56, 161, 105, 0.08)',
					mb: 2,
				}}
			>
				<Typography
					variant="caption"
					sx={{ fontWeight: 700, display: 'block' }}
				>
					Payment by check
				</Typography>
				<Typography
					variant="caption"
					color="text.secondary"
					sx={{ lineHeight: 1.6 }}
				>
					Please make your check payable to Ridgeline Trade Co. and mail it to
					1847 Ridgeview Dr, Denver, CO 80202.
				</Typography>
			</Box>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'block', lineHeight: 1.6 }}
			>
				Please find the attached invoice PDF for your records.
			</Typography>
		</Box>
		<Box sx={{ px: 2, py: 1.5, bgcolor: 'action.hover', textAlign: 'center' }}>
			<Typography variant="caption" color="text.secondary">
				Ridgeline Trade Co. · hello@ridgelinetrade.co | (303) 555-0142
			</Typography>
		</Box>
	</Paper>
);

export const ReminderMockup = () => (
	<Paper
		elevation={0}
		sx={{
			borderRadius: 3,
			border: '1px solid',
			borderColor: 'divider',
			overflow: 'hidden',
			height: '100%',
		}}
	>
		<Box
			sx={{
				px: 2,
				py: 1.5,
				bgcolor: '#1a202c',
				color: '#ffffff',
				textAlign: 'center',
			}}
		>
			<Box
				sx={{
					width: 36,
					height: 36,
					borderRadius: '50%',
					bgcolor: 'primary.main',
					mx: 'auto',
					mb: 1,
				}}
			/>
			<Typography
				variant="caption"
				sx={{ display: 'block', opacity: 0.85, mb: 0.5 }}
			>
				From: Ridgeline Trade Co.
			</Typography>
			<Typography
				variant="subtitle2"
				sx={{ fontWeight: 700, letterSpacing: '0.04em' }}
			>
				RIDGELINE TRADE CO.
			</Typography>
		</Box>
		<Box
			sx={{
				px: 2,
				py: 1.25,
				borderBottom: '1px solid',
				borderColor: 'divider',
			}}
		>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'block' }}
			>
				Subject
			</Typography>
			<Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
				Reminder: please review your proposal - Kitchen Remodel
			</Typography>
		</Box>
		<Box sx={{ p: 2.5 }}>
			<Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
				Reminder: please review your proposal
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
				Hello Alex,
			</Typography>
			<Typography variant="body2" sx={{ mb: 2, lineHeight: 1.7 }}>
				This is a friendly reminder to take a look at the proposal below. When
				you are ready, you can accept or decline from this email.
			</Typography>
			<Box
				sx={{
					p: 2,
					borderRadius: 1,
					borderLeft: '4px solid',
					borderColor: 'warning.main',
					bgcolor: 'action.hover',
					mb: 2,
				}}
			>
				<Typography variant="body2">
					<strong>Job:</strong> Kitchen Remodel
				</Typography>
				<Typography variant="body2" sx={{ mt: 1 }}>
					<strong>Amount:</strong>{' '}
					<Box component="span" sx={{ color: 'info.main', fontWeight: 700 }}>
						$8,450.00
					</Box>
				</Typography>
				<Typography
					variant="caption"
					sx={{ display: 'block', mt: 1, fontWeight: 700 }}
				>
					This proposal expires on 07/23/2026
				</Typography>
			</Box>
			<Stack
				direction="row"
				spacing={1}
				justifyContent="center"
				sx={{ mb: 1.5 }}
			>
				<Button
					size="small"
					variant="contained"
					sx={{ minWidth: 100, pointerEvents: 'none' }}
				>
					Accept this bid
				</Button>
				<Button size="small" color="inherit" sx={{ pointerEvents: 'none' }}>
					Decline
				</Button>
			</Stack>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'block', textAlign: 'center', lineHeight: 1.5 }}
			>
				By clicking Accept, you agree to the terms of this proposal and
				authorize Ridgeline Trade Co. to proceed with the work described.
			</Typography>
		</Box>
		<Box sx={{ px: 2, py: 1.5, bgcolor: 'action.hover', textAlign: 'center' }}>
			<Typography variant="caption" color="text.secondary">
				Ridgeline Trade Co. · hello@ridgelinetrade.co | (303) 555-0142
			</Typography>
		</Box>
	</Paper>
);

